import React from 'react';

interface ToggleBtnProps {
  label: string;
  active: boolean;
  onClick: () => void;
  /** 'default' = blue (#0066cc), 'purple' = (#6753ac). Default: 'default'. */
  variant?: 'default' | 'purple';
}

export const ToggleBtn: React.FC<ToggleBtnProps> = ({ label, active, onClick, variant = 'default' }) => {
  const activeClass = active
    ? variant === 'purple' ? 'ua-toggle-btn--active-purple' : 'ua-toggle-btn--active'
    : '';
  return (
    <button
      type="button"
      onClick={onClick}
      className={`ua-toggle-btn${activeClass ? ` ${activeClass}` : ''}`}
    >
      {label}
    </button>
  );
};
